import { render } from "./SpecialProcess.vue?vue&type=template&id=2cfb4714&scoped=true&ts=true&lang=pug"
import script from "./SpecialProcess.vue?vue&type=script&lang=ts"
export * from "./SpecialProcess.vue?vue&type=script&lang=ts"

import "./SpecialProcess.vue?vue&type=style&index=0&id=2cfb4714&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfb4714"]])

export default __exports__